import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Service/defend/ISOStandard/ISOStandard.tsx");
